import React from 'react';
import logo from './logo.svg';
import Home from'./Home';
import About from'./About';
import ContactPAge from'./Contact';
import Gallery from './Gallery';
import ServicesPage from './Services'
import Error from'./Error';
import Navbar from'./navbar';

import {Route,Switch} from "react-router-dom"

import './App.css';
import PressRelease from './Press-Release';

function App() {
  return (		  
		  <>
		 <Navbar />
 		<Switch>
		<Route path="/" exact component={Home} />
        <Route path="/About" exact component={About} />
		<Route path="/Contact" exact component={ContactPAge} />
		<Route path="/Services" exact component={ServicesPage} />
		<Route path="/Press-Release" exact component={PressRelease} />
		<Route path="/Gallery" exact component={Gallery} />
		<Route component={Error} />
		  </Switch>
		  </>
     
  );
}

export default App;
